import { useQuery } from "@apollo/client"
import { GET_MY_ORGANIZATION_PENDING_INVITATIONS } from "../graphql/queries/getMyOrganizationPendingInvitations"
import { OrganizationType } from "../utils/models"

type QueryType = {
  myOrganization: OrganizationType
}

export const useMyOrganizationPendingInvitations = () => {
  const { data, error, loading, refetch } = useQuery<QueryType>(GET_MY_ORGANIZATION_PENDING_INVITATIONS)
  return { pendingInvites: data?.myOrganization?.pendingInvitations, error, loading, refetch }
}
